import React, { useState } from "react";

import axios from "axios";

import {
  Trophy,
  ShieldAlert,
  Loader2,
  CheckCircle2,
  X,
  Lock,
  Flame,
  BarChart3,
} from "lucide-react";



// =========================
// API Base
// =========================

const API_BASE =
  process.env.REACT_APP_API_URL ||

  (window.location.hostname ===
  "localhost"

    ? "http://localhost:5000"

    : "https://upsc-backend-353e.onrender.com");



const DisplayNameModal = ({
  onSuccess,
  onClose,
}) => {

  const user = JSON.parse(
    localStorage.getItem("user")
  );

  const token = user?.token;



  const [displayName,
    setDisplayName] =
    useState("");

  const [loading,
    setLoading] =
    useState(false);

  const [error,
    setError] =
    useState("");

  const [success,
    setSuccess] =
    useState("");



  // =========================
  // Close Modal
  // =========================

  const handleClose = () => {    
    if (onClose) {
      onClose();
    }
  };



  // =========================
  // Submit
  // =========================

  const handleSubmit = async (
    e
  ) => {

    e.preventDefault();

    setError("");

    setSuccess("");

    setLoading(true);


    try {

      const res =
        await axios.post(

          `${API_BASE}/api/display-name/set`,

          { displayName },

          {
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );



      // =========================
// Updated User From Backend
// =========================

const updatedUser = {

  ...(res.data?.user || {}),

  token,

  displayName:
    res.data?.displayName ||

    displayName,

  isCompetitiveProfileEnabled:
    true,
};



// =========================
// Save Updated User
// =========================

localStorage.setItem(

  "user",

  JSON.stringify(
    updatedUser
  )
);



// =========================
// Notify Whole App
// =========================

window.dispatchEvent(

  new Event(
    "userUpdated"
  )
);



// =========================
// Success UI
// =========================

setSuccess(

  "🏆 Competitive profile activated successfully"
);



// =========================
// Close Modal
// =========================

setTimeout(() => {

  if (onSuccess) {

    onSuccess(
      updatedUser
    );
  }

}, 1200);

} catch (err) {

  console.error(err);

  setError(

    err?.response?.data?.message ||

    "Failed to set display name"
  );
}

setLoading(false);
  };



  return (

    <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-md overflow-y-auto py-10 px-4">

      <div className="relative w-full max-w-2xl mx-auto overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-gray-900 via-zinc-900 to-black shadow-2xl"
>


        {/* Close Button */}
        <button

          onClick={handleClose}

          className="absolute top-5 right-5 z-20 w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-gray-300 hover:text-white transition"
        >
          <X className="w-5 h-5" />
        </button>



        {/* Glow */}
        <div className="absolute inset-0 opacity-20">

          <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500 rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 right-0 w-72 h-72 bg-purple-500 rounded-full blur-3xl"></div>
        </div>



        <div className="relative z-10 p-8 md:p-10 text-white">

          {/* Header */}
          <div className="flex items-center gap-4 mb-8">

            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-xl">

              <Trophy className="w-8 h-8 text-white" />
            </div>

            <div>

              <h2 className="text-3xl font-extrabold">

                Enter the UPSC Arena
              </h2>

              <p className="text-gray-400 mt-1">

                Unlock the competitive preparation ecosystem.
              </p>
            </div>
          </div>



          {/* Explanation */}
          <div className="mb-8">

            <p className="text-gray-300 leading-relaxed text-[15px]">

              Your public display name allows you to participate anonymously in the UPSC competitive ecosystem.

              Your real identity always remains private while you compete with other aspirants through rankings, streaks, XP and advanced preparation analytics.
            </p>
          </div>



          {/* Premium Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex items-center gap-3">

              <Trophy className="w-5 h-5 text-yellow-400" />

              <span>
                Leaderboards & Rankings
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex items-center gap-3">

              <BarChart3 className="w-5 h-5 text-cyan-400" />

              <span>
                Competitive Analytics
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex items-center gap-3">

              <Flame className="w-5 h-5 text-orange-400" />

              <span>
                XP & Streak Competition
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex items-center gap-3">

              <Lock className="w-5 h-5 text-pink-400" />

              <span>
                AIR Simulation System
              </span>
            </div>
          </div>



          {/* Warning */}
          <div className="flex items-start gap-3 bg-red-500/10 border border-red-500/20 rounded-2xl p-5 mb-8">

            <ShieldAlert className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />

            <div>

              <h3 className="font-bold text-red-300 mb-1">

                Important Guidelines
              </h3>

              <p className="text-sm text-gray-300 leading-relaxed">

                Vulgar, abusive, hateful, adult, political or impersonating usernames are strictly prohibited.

                Accounts violating these guidelines may permanently lose access to the competitive ecosystem.
              </p>
            </div>
          </div>



          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className="space-y-6"
          >

            <div>

              <label className="block mb-3 font-semibold text-gray-300">

                Public Display Name
              </label>

              <input
                type="text"

                value={displayName}

                onChange={(e) =>
                  setDisplayName(
                    e.target.value
                  )
                }

                placeholder="Example: PolityNinja"

                className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500"
              />

              <p className="mt-3 text-sm text-gray-400">

                3-20 characters • letters, numbers, spaces and underscores only
              </p>
            </div>



            {/* Error */}
            {error && (

              <div className="bg-red-500/10 border border-red-500/20 text-red-300 px-5 py-4 rounded-2xl">

                {error}
              </div>
            )}



            {/* Success */}
            {success && (

              <div className="flex items-center gap-2 bg-green-500/10 border border-green-500/20 text-green-300 px-5 py-4 rounded-2xl">

                <CheckCircle2 className="w-5 h-5" />

                {success}
              </div>
            )}



            {/* Submit */}
            <button
              type="submit"

              disabled={loading}

              className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold py-4 rounded-2xl transition-all duration-300 shadow-2xl"
            >

              {loading ? (

                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Activating Identity...
                </>

              ) : (

                <>
                  🚀 Activate Competitive Profile
                </>
              )}
            </button>                    

          </form>
        </div>
      </div>
    </div>
  );
};

export default DisplayNameModal;